import { App } from "vue";

export class HttpBase {
  private vueInstance: App | undefined = undefined;

  getVueInstance() {
    if (!this.vueInstance) {
      throw new Error(
        "HttpBase: The value of vueInstance is undefine, which should be set."
      );
    }

    return this.vueInstance;
  }

  setVueInstance(app: App) {
    this.vueInstance = app;
  }
}
